import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import React from "react";

import styles from "../index.module.css";

interface ParamProps {
  fieldName: string;
  label: string;
  currentObject: any;
  isDisable?: boolean;
  isInvalid?: boolean;
  getValue: string | undefined | null;
  setValue: (updatedObject: any) => void;
  isLink?: boolean;
  style?: React.CSSProperties;
}

const InputTextComponent: React.FC<ParamProps> = (
  params
) => {
  const value = params.getValue ?? "";

  const isLinkValid =
    params.isLink &&
    value.trim().toLowerCase() !==
      "to be checked" &&
    value.trim().length > 0;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const updatedObject = {
      ...params.currentObject,
      [params.fieldName]: e.target.value,
    };

    params.setValue(updatedObject);
  };

  const handleOpen = () => {
    if (isLinkValid) {
      window.open(
        value,
        "_blank",
        "noopener,noreferrer"
      );
    }
  };

  return (
    <FloatLabel className={styles.floatLabel}>
      <InputText
        id={params.fieldName}
        className={`w-full ${
          isLinkValid ? "cursor-pointer" : ""
        }`}
        value={value}
        disabled={
          params.isDisable && !isLinkValid
        }
        readOnly={
          params.isDisable && isLinkValid
        }
        invalid={params.isInvalid || false}
        onChange={handleChange}
        onClick={handleOpen}
        style={{
          cursor: isLinkValid ? "pointer" : undefined,
          color: isLinkValid ? "#0a66c2" : undefined,
          ...params.style,
        }}
      />

      <label
        className={styles.label}
        htmlFor={params.fieldName}
      >
        {params.label}
      </label>
    </FloatLabel>
  );
};

export default InputTextComponent;